// ═══════════════════════════════════════════════════════════════════════════════
// ui--manifesto--sticky-horizontal-v3
// ───────────────────────────────────────────────────────────────────────────────
// Wraps GSAP ScrollTrigger — pinned horizontal scroll секция.
// Markup expectations:
//   <div data-controller="ui--manifesto--sticky-horizontal-v3"
//        data-ui--manifesto--sticky-horizontal-v3-target="track">
//     <div data-ui--manifesto--sticky-horizontal-v3-target="track"
//          class="flex h-full">
//       <div class="panel">...</div>  ← N panels
//     </div>
//   </div>
// ═══════════════════════════════════════════════════════════════════════════════

import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default class extends Controller {
  static targets = ["track"]
  static values = {
    scrubAmount: { type: Number, default: 1 },
    pinSpacing:  { type: Boolean, default: true },
  }

  connect() {
    if (!this.hasTrackTarget) {
      console.warn("[sticky-horizontal-v3] missing track target")
      return
    }

    const panels = this.trackTarget.children
    const total = panels.length
    if (total <= 1) return

    const distance = `+=${this.element.offsetWidth * (total - 1)}`

    this.tween = gsap.to(this.trackTarget, {
      xPercent: -100 * (total - 1) / total * (total) / total, // равно -100*(total-1)
      x: -(this.trackTarget.scrollWidth - this.element.offsetWidth),
      ease: "none",
      scrollTrigger: {
        trigger: this.element,
        pin: true,
        pinSpacing: this.pinSpacingValue,
        scrub: this.scrubAmountValue,
        end: distance,
        invalidateOnRefresh: true,
      },
    })
  }

  disconnect() {
    this.tween?.scrollTrigger?.kill()
    this.tween?.kill()
  }
}
